import {
    GET_FILTER_RECONCILIATION_FAILD, GET_FILTER_RECONCILIATION_SUCCESS, GET_FILTER_RECONCILIATION_LOADING, GET_FILTER_RECONCILIATION_RESET, GET_FILTER_INVOICES_FAILD
} from "../types";

const initialState = {
    loading: false,
    error: null,
    reconciliationList: null,
    status: null
};

export const getReconciliationFilterReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status: any }
) => {
    switch (action.type) {
        case GET_FILTER_RECONCILIATION_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_FILTER_RECONCILIATION_SUCCESS:
            return {
                ...state,
                loading: false,
                reconciliationList: action.payload,
                status: action.status,
                error: null,
            };
        case GET_FILTER_RECONCILIATION_FAILD:
            return {
                ...state,
                loading: false,
                reconciliationList: null,
                status: action.status,
                error: action.error,
            };
        case GET_FILTER_RECONCILIATION_RESET:
            return initialState;
        default:
            return state;
    }
};
